import React, { useState } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ProviderReceiptReportFilter from "./filter"
import MonitorReceiptReportFilter from "./filter"

const MonitorReceiptReportListComponent = ({
  data,
  error,
  loading,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onExportBtnClick,
  onAdvancedSearchSubmit,
  exportStatus,
  onPageClick,
}) => {
  const navigate = useNavigate()
  const [filterOpen, setFilterOpen] = useState(false)

  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CustomHeaderTitle
            loading={loading}
            // pageRowNumberOptions={[20, 100, 150]}
            title={""}
            exportBtn={true}
            exportBtnLoading={exportStatus?.loading}
            onExportBtnClick={onExportBtnClick}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={true}
            onSearchHandler={onSearch}
            rightBtn={false}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
            orderingOptions={[
              { value: "date", name: "Date" },
              //   { value: "date", name: "Submission Date" },
            ]}
          />
          <Collapse isOpen={filterOpen}>
            <MonitorReceiptReportFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>
          <GeneralTables
            data={data?.data}
            loading={loading}
            headers={[
              "PROVIDER",
              "WAREHOUSE NAME",
              "TRANSACTION DATE",
              "TRANSACTION TYPE",
              "UNFPA ITEM ID",
              "P- ITEM DESCRIPTION",
              "UNFPA UOM",
              "IP UOM",
              "UNIT PRICE (AS PER UNFPA)",
              "UNIT PRICE (AS PER IP UOM)",
              "BATCH / LOT NUMBER",
              "EXPIRY / BEST BEFORE DATE",
              "QUANTITY (UNFPA UOM)",
              "QUANTITY (IP UOM)",
              "VALUE ( AS PER UNFPA UOM)",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(transaction, index) => (
              <tr key={index}>
                <td style={{ whiteSpace: "nowrap" }}>
                  {transaction?.ProviderIp}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {transaction?.warehouse?.name}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>{transaction?.date}</td>
                <td style={{ whiteSpace: "nowrap" }}>{transaction?.type}</td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {transaction?.item?.unfp_item_name}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {transaction?.item?.ip_item_description}
                </td>

                <td>
                  {transaction?.item?.uom} &nbsp;
                  {transaction?.unit_uom_quantity_per_unfpa > 1 &&
                    transaction?.unit_uom_quantity_per_unfpa}
                </td>
                <td>
                  {transaction?.item?.ip_unit_umo} &nbsp;
                  {transaction?.unit_umo_quantity_per_ip > 1 &&
                    transaction?.unit_umo_quantity_per_ip}
                </td>
                <td>{transaction?.unit_price_per_unfpa}</td>
                <td>{transaction?.unit_price_per_ip}</td>
                <td>{transaction?.batch_number}</td>
                <td>{transaction?.expire_date}</td>
                <td>{transaction?.qty_per_unfpa}</td>
                <td>{transaction?.qty_per_ip}</td>
                <td>{transaction?.total_value}</td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonitorReceiptReportListComponent
